import { ProductType as CourseType } from "@/common/course/types";
import { prioritizeOpenCoursesTab } from "@/components/ProductCardListWrapper/variants/ProductCardTabsAndPillsByUUID/utils/prioritizeOpenCoursesTab";
import { sortTrendingCategoriesByKeyOrder } from "@/components/ProductCardListWrapper/variants/ProductCardTabsAndPillsByUUID/utils/sortTrendingCategoriesByKeyOrder";
import type {
  Category,
  TrendingOnEdxProductTabsResult,
} from "@/components/ProductCardListWrapper/variants/ProductCardListBySearchTab/types";

export function getFilteredTrendingCategories(
  categories: Category[] | undefined,
  trending: TrendingOnEdxProductTabsResult,
): Category[] {
  const withoutBootcamps =
    categories?.filter((category) => {
      return category.productType !== CourseType.BOOTCAMP;
    }) ?? [];

  // Only baseline/CMS order when not in the A/B `test` variant (includes flag loading).
  // When `variant === "test"` and `isLoading` (Monarch in flight), `useHomepageTrendingCourseUpdate`
  // still exposes `data: TEST_DEFAULTS` — apply it so tab order does not jump after fetch.
  if (trending.variant === "legacy") {
    return withoutBootcamps;
  }

  const { categoryKeyOrder, prioritizeCoursesFirst } = trending.data;
  if (categoryKeyOrder?.length) {
    return sortTrendingCategoriesByKeyOrder(withoutBootcamps, categoryKeyOrder);
  }
  if (prioritizeCoursesFirst) {
    return prioritizeOpenCoursesTab(withoutBootcamps);
  }
  return withoutBootcamps;
}
